import {queryClient} from 'app/react-query'
import axios from 'axios'
import {Suspense, useEffect} from 'react'
import {QueryClientProvider} from 'react-query'
import {Outlet, useNavigate} from 'react-router-dom'
import ToolbarProvider from './components/toolbar/ToolbarProvider'

import {LayoutSplashScreen} from './layouts/LayoutSplashScreen'

import {retrieveIscoutDestination} from './modules/cognito'

export const WikiDataAxios = axios.create({
  baseURL: 'https://www.wikidata.org/w/rest.php/wikibase/v1/entities/',
  timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const App = () => {
  const navigate = useNavigate()
  const destination = retrieveIscoutDestination()

  useEffect(() => {
    if (destination) {
      console.log(`Navigating to pre-authentication destination: ${destination}`)
      navigate(destination)
    }
  }, [destination])
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <QueryClientProvider client={queryClient}>
        <ToolbarProvider>
          <Outlet />
        </ToolbarProvider>
      </QueryClientProvider>
    </Suspense>
  )
}

export {App}
